import { render, staticRenderFns } from "./ReviewNotesForm.vue?vue&type=template&id=c60eaf40&scoped=true"
import script from "./ReviewNotesForm.vue?vue&type=script&lang=js"
export * from "./ReviewNotesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c60eaf40",
  null
  
)

export default component.exports